import { format } from 'date-fns';
import { isDateToday, isDateTomorrow } from 'utils/date-formatter';

export const eventCalendarDisplayableDate = (eventDate) => {
  if (isDateToday(eventDate)) {
    return 'Today';
  }
  if (isDateTomorrow(eventDate)) {
    return 'Tomorrow';
  }

  return format(eventDate, 'EEEE do MMMM');
};
